import Point from "@arcgis/core/geometry/Point";
import Geometry from "@arcgis/core/geometry/Geometry";
import axios from "axios";
import React, { useState } from "react";
import { Card, Col, Form, FormControlProps, Row } from "react-bootstrap";
import BUTTON from "../button/Button.component";
import { LOCATOR_URL } from "../map/Map.constants";
import { IMapPoint } from "../map/Map.types";
import MapUtils from "../map/Map.utils";
import DashboardStyles from "./Dashboard.styles";
import DashboardUtils, { IAddressLookupResponse } from "./Dashboard.utils";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils";
import { Link } from "react-router-dom";

const DASHBOARD: React.FC<Record<string, unknown>> = () => {
  const initialFormData = {
    latitude: "",
    longitude: "",
  };

  const initialGeoLocResults: any = {
    streetAddress: null,
    pointAddress: null,
    xStreets: null,
    poi: null,
  };

  const [formData, updateFormData] = useState(initialFormData);
  const [geoLocResults, setGeoLocResults] = useState(initialGeoLocResults);

  /**
   * handleChange
   * @param {React.ChangeEvent<any>} event
   */
  const handleChange = (event: React.ChangeEvent<any>) => {
    updateFormData({
      ...formData,
      // Trimming any whitespace
      [event.target.name]: event.target.value.trim(),
    });
  };

  /**
   * handleAddressLookup
   * @param {React.FormEvent<HTMLFormElement>} event
   */
  const handleAddressLookup = async (
    event: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    event.preventDefault();
    const lat = parseFloat(formData.latitude);
    const lng = parseFloat(formData.longitude);

    DashboardUtils.fetchAddressData(
      new Point({
        longitude: lng,
        latitude: lat,
      })
    )
      .then((results: IAddressLookupResponse) => {
        const {
          streetAddressResponse,
          pointAddressResponse,
          xStreetResponse,
          poiResponse,
        } = results;

        setGeoLocResults({
          streetAddress: streetAddressResponse.data,
          pointAddress: pointAddressResponse.data,
          xStreets: xStreetResponse.data,
          poi: poiResponse.data,
        });

        return Promise.resolve(results);
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error);
      });
  };

  return (
    <DashboardStyles.DashboadContainer className="dashboard-container">
      <Row>
        <Col>
          <h1>Testing Dashboard</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title>Address Lookup</Card.Title>
              <Form
                onSubmit={(event: React.FormEvent<HTMLFormElement>) =>
                  handleAddressLookup(event)
                }
              >
                <Form.Group className="mb-3" controlId="latitude">
                  <Form.Label>Latitude</Form.Label>
                  <Form.Control
                    type="text"
                    name="latitude"
                    placeholder="Enter latitude"
                    onChange={(event: React.ChangeEvent<any>) => {
                      handleChange(event);
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="longitude">
                  <Form.Label>Longitude</Form.Label>
                  <Form.Control
                    type="text"
                    name="longitude"
                    placeholder="Enter longitude"
                    onChange={(event: React.ChangeEvent<any>) => {
                      handleChange(event);
                    }}
                  />
                </Form.Group>
                <BUTTON variant="primary" type="submit">
                  Get Address
                </BUTTON>
              </Form>

              <DashboardStyles.ResultsContainer className="results-container">
                {geoLocResults.streetAddress &&
                  !geoLocResults.streetAddress.error && (
                    <Card.Text>
                      <h4>Street Address Results:</h4>
                      <ul>
                        <li>
                          Address: {geoLocResults.streetAddress.address.Address}
                        </li>
                        <li>
                          Long Label:{" "}
                          {geoLocResults.streetAddress.address.LongLabel}
                        </li>
                        <li>
                          Short Label:{" "}
                          {geoLocResults.streetAddress.address.ShortLabel}
                        </li>
                        <li>
                          Match Address:{" "}
                          {geoLocResults.streetAddress.address.Match_addr}
                        </li>
                      </ul>
                    </Card.Text>
                  )}
                {geoLocResults.pointAddress &&
                  !geoLocResults.pointAddress.error && (
                    <Card.Text>
                      <h4>Point Address Results:</h4>
                      <ul>
                        <li>
                          Address: {geoLocResults.pointAddress.address.Address}
                        </li>
                        <li>
                          Long Label:{" "}
                          {geoLocResults.pointAddress.address.LongLabel}
                        </li>
                        <li>
                          Short Label:{" "}
                          {geoLocResults.pointAddress.address.ShortLabel}
                        </li>
                        <li>
                          Match Address:{" "}
                          {geoLocResults.pointAddress.address.Match_addr}
                        </li>
                      </ul>
                    </Card.Text>
                  )}
                {geoLocResults.xStreets && !geoLocResults.xStreets.error && (
                  <Card.Text>
                    <h4>Cross Street Results:</h4>
                    <ul>
                      <li>Address: {geoLocResults.xStreets.address.Address}</li>
                      <li>
                        Long Label: {geoLocResults.xStreets.address.LongLabel}
                      </li>
                      <li>
                        Short Label: {geoLocResults.xStreets.address.ShortLabel}
                      </li>
                      <li>
                        Match Address:{" "}
                        {geoLocResults.xStreets.address.Match_addr}
                      </li>
                    </ul>
                  </Card.Text>
                )}
                {geoLocResults.poi && !geoLocResults.poi.error && (
                  <Card.Text>
                    <h4>Point of Interest Results:</h4>
                    <ul>
                      <li>Address: {geoLocResults.poi.address.Address}</li>
                      <li>Long Label: {geoLocResults.poi.address.LongLabel}</li>
                      <li>
                        Short Label: {geoLocResults.poi.address.ShortLabel}
                      </li>
                      <li>
                        Match Address: {geoLocResults.poi.address.Match_addr}
                      </li>
                    </ul>
                  </Card.Text>
                )}
              </DashboardStyles.ResultsContainer>
            </Card.Body>
          </Card>
        </Col>
        <Col></Col>
        <Col></Col>
      </Row>
    </DashboardStyles.DashboadContainer>
  );
};

export default DASHBOARD;
